export const APP_NAME = 'candidate-client';

export const HEAP_ANALYTICS_EVENTS = {
  CANDIDATE_STAGE_CARDS_LIST_PAGE_VISIT:
    'candidate-stage-cards-list-page-visit',
  CANDIDATE_STAGE_AI_INTERVIEW_STAGE_CARD_CLICK:
    'candidate-stage-ai-interview-stage-card-click',
  CANDIDATE_AI_INTERVIEW_CONFERENCE_ROOM_CONNECTED:
    'candidate-ai-interview-conference-room-connected',
  CANDIDATE_AI_INTERVIEW_CONFERENCE_ROOM_DISCONNECTED:
    'candidate-ai-interview-conference-room-disconnected',
  CANDIDATE_AI_INTERVIEW_CONFERENCE_FAILED:
    'candidate-ai-interview-conference-failed',
  CANDIDATE_AI_INTERVIEW_SOMETHING_WENT_WRONG_MODAL_DISMISS:
    'candidate-ai-interview-something-went-wrong-modal-dismiss',
  CANDIDATE_AI_INTERVIEW_START_SCREEN_PAGE_VISIT:
    'candidate-ai-interview-start-screen-page-visit',
  CANDIDATE_AI_INTERVIEW_START_SCREEN_CONTINUE_BUTTON_CLICK:
    'candidate-ai-interview-start-screen-continue-button-click',
  CANDIDATE_AI_INTERVIEW_PERMISSIONS_PAGE_VISIT:
    'candidate-ai-interview-permissions-page-visit',
  CANDIDATE_AI_INTERVIEW_PERMISSIONS_GRANT_ACCESS_BUTTON_CLICK:
    'candidate-ai-interview-permissions-grant-access-button-click',
  CANDIDATE_AI_INTERVIEW_PERMISSIONS_START_INTERVIEW_BUTTON_CLICK:
    'candidate-ai-interview-permissions-start-interview-button-click',
  CANDIDATE_AI_INTERVIEW_CONFERENCE_ROOM_PAGE_VISIT:
    'candidate-ai-interview-conference-room-page-visit',
  CANDIDATE_AI_INTERVIEW_CONFERENCE_ROOM_END_CALL_BUTTON_CLICK:
    'candidate-ai-interview-conference-room-end-call-button-click',
  CANDIDATE_AI_INTERVIEW_CONFERENCE_ROOM_END_CALL_CONFIRM_MODAL_CLICK:
    'candidate-ai-interview-conference-room-end-call-confirm-modal-click',
  CANDIDATE_AI_INTERVIEW_CONFERENCE_ROOM_END_CALL_CANCEL_MODAL_CLICK:
    'candidate-ai-interview-conference-room-end-call-cancel-modal-click',
  CANDIDATE_AI_INTERVIEW_FEEDBACK_PAGE_VISIT:
    'candidate-ai-interview-feedback-page-visit',
  CANDIDATE_AI_INTERVIEW_FEEDBACK_TEXT_EDIT:
    'candidate-ai-interview-feedback-text-edit',
  CANDIDATE_AI_INTERVIEW_FEEDBACK_SLIDER_CHANGE:
    'candidate-ai-interview-feedback-slider-change',
  CANDIDATE_AI_INTERVIEW_FEEDBACK_SUBMIT_BUTTON_CLICK:
    'candidate-ai-interview-feedback-submit-button-click',
  CANDIDATE_AI_INTERVIEW_BACK_LINK_CLICK:
    'candidate-ai-interview-back-link-click',
  CANDIDATE_AI_INTERVIEW_AVATAR_SELECTION_PAGE_VISIT:
    'candidate-ai-interview-avatar-selection-page-visit',
  CANDIDATE_AI_INTERVIEW_AVATAR_SELECTION_OPTION_CLICK:
    'candidate-ai-interview-avatar-selection-option-click',
  CANDIDATE_AI_INTERVIEW_AVATAR_SELECTION_CONTINUE_BUTTON_CLICK:
    'candidate-ai-interview-avatar-selection-continue-button-click',
  CANDIDATE_AI_INTERVIEW_DEMO_TEST_CALL_START:
    'candidate-ai-interview-demo-test-call-start',
  CANDIDATE_AI_INTERVIEW_DEMO_TEST_CALL_END_BY_USER:
    'candidate-ai-interview-demo-test-call-end-by-user',
  CANDIDATE_AI_INTERVIEW_DEMO_TEST_CALL_END_BY_TIMER:
    'candidate-ai-interview-demo-test-call-end-by-timer',
  CANDIDATE_AI_INTERVIEW_DEMO_BACK_TO_CONFIG:
    'candidate-ai-interview-demo-back-to-config',
  CANDIDATE_AI_INTERVIEW_DEMO_START_REAL_INTERVIEW:
    'candidate-ai-interview-demo-start-real-interview',
  CANDIDATE_AI_INTERVIEW_DEMO_LIMIT_REACHED:
    'candidate-ai-interview-demo-limit-reached',
  CANDIDATE_AI_INTERVIEW_PRACTICE_PREVIEW_TRY_PRACTICE_CLICK:
    'candidate-ai-interview-practice-preview-try-practice-click',
  CANDIDATE_AI_INTERVIEW_PRACTICE_PREVIEW_SKIP_TO_INTERVIEW_CLICK:
    'candidate-ai-interview-practice-preview-skip-to-interview-click',
  CANDIDATE_AI_INTERVIEW_PRACTICE_PREVIEW_START_INTERVIEW_CLICK:
    'candidate-ai-interview-practice-preview-start-interview-click',
};
